import React, { Component } from 'react';
import { Segment, Container } from 'semantic-ui-react';
import { t } from 'i18next';
import ContainedLayout from '../components/layout/ContainedLayout';

class Login extends Component {
  render() {
    return (
      <ContainedLayout>
        <div className="Login">
          <Container text>
            <Segment vertical>
              <div></div>
            </Segment>
          </Container>
        </div>
      </ContainedLayout>
    );
  }
}

export default Login;
